import type { Usuario } from '@/types/Autenticacao/Usuario'
import type { Cartorio } from '@/types/Autenticacao/Cartorio'

type UsuarioAtual = {
  usuario: Usuario
  cartorios: Cartorio[]
  cartorio: Cartorio
}

export const useUsuarioStore = defineStore('usuarioStore', {
  state: () => ({
    usuarioAtual: {
      usuario: {} as Usuario,
      cartorios: [] as Cartorio[],
      cartorio: {} as Cartorio,
      calendarioId: '',
    } as UsuarioAtual,
  }),
  actions: {
    getBgCor (cor: string): string {
      if (cor === 'red') {
        return '#f44336'
      }

      if (cor === 'purple') {
        return '#9c27b0'
      }

      if (cor === 'blue') {
        return '#2196f3'
      }

      if (cor === 'cyan') {
        return '#00bcd4'
      }

      if (cor === 'teal') {
        return '#009688'
      }

      if (cor === 'green') {
        return '#4caf50'
      }

      if (cor === 'orange') {
        return '#ff9800'
      }

      if (cor === 'brown') {
        return '#795548'
      }

      if (cor === 'bluegray') {
        return '#607d8b'
      }

      if (cor === 'black') {
        return '#000000'
      }

      return '#808080'
    },

    async selecionarCartorio (id: string, manterContexto = false) {
      const resposta = await useApiStore().request('/autenticacao/selecionar/' + id) as any

      if (resposta?.token) {
        let cartorio = {}

        if (id === 'admin') {
          cartorio = {
            id: 'admin',
            cns: 'Admin CV',
            cor: 'padrao',
            especialidades: [],
          }
        } else {
          this.usuarioAtual.cartorios.forEach(function (valor) {
            if (valor.id === id) {
              cartorio = valor
            }
          })
        }

        this.$patch({
          usuarioAtual: {
            ...this.usuarioAtual,
            usuario: resposta?.usuario || this.usuarioAtual.usuario,
            cartorio,
          },
        })

        if (!manterContexto) {
          useStore().resetarCompetencia()
          await useRouter().push('/')
          useDashboardStore().$reset()
          usePrestacaoDeContaStore().$reset()
          useLivroDiarioAuxiliarStore().$reset()
          useAtividadesStore().$reset()
        }

        useAutenticacaoStore().token = resposta?.token
        useApiStore().request('/lark/calendar') // Cria um calendário se não existir

        if (!manterContexto) {
          await useAtividadesStore().carregarResumo()
          await useAtividadesStore().carregarAtividadesPaginadas(1, 10, true)
        }
      }
    },

    formatarNomeCartorio (cartorio: Cartorio): string {
      if (!cartorio) { return '' }

      const nomeFantasia = cartorio.nome_fantasia ? cartorio.nome_fantasia + ' - ' : ''
      const tipo = cartorio.cns?.length === 11 ? 'CPF' : (cartorio.tipo_perfil_organizacao === 'contador' ? 'CONT' : 'CNS')
      const documento = useStore().formatarCns(cartorio.cns)

      return `${nomeFantasia}${tipo} ${documento}`
    },
  },
  getters: {
    cartorioAtual (state): Cartorio {
      return state.usuarioAtual.cartorio
    },
    cartorios (state): Cartorio[] {
      return state.usuarioAtual.cartorios
    },
  },
  persist: {
    paths: ['usuarioAtual'],
    storage: localStorage,
  },
})
